document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector(
    '.product-list-promotion-banner__slide.swiper-container'
  )
  if (!el) return

  const controller = document.querySelector('.product-list-promotion-banner__controller')
  function updateControllerColor(slide) {
    const colorMode = slide.dataset.colorMode
    if (!controller) return

    const icons = controller.querySelectorAll('i')

    if (colorMode === 'light') {
      controller.classList.add('is-light')
      icons.forEach((icon) => (icon.style.backgroundColor = 'var(--color-gray-000)'))
    } else {
      controller.classList.remove('is-light')
      icons.forEach((icon) => (icon.style.backgroundColor = 'var(--color-gray-100)'))
    }
  }

  const swiper = new Swiper(el, {
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    pagination: {
      el: '.product-list-promotion-banner__controller-pagination',
      type: 'fraction',
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="sr-only">current slide</span>' +
          '<span class="' +
          currentClass +
          '"></span>' +
          '<span aria-hidden="true"> / </span>' +
          '<span class="sr-only">total slide</span>' +
          '<span class="' +
          totalClass +
          '"></span>'
        )
      },
    },
    navigation: {
      nextEl: '.product-list-promotion-banner__controller-next',
      prevEl: '.product-list-promotion-banner__controller-prev',
    },
    a11y: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    on: {
      init: function () {
        const activeSlide = this.slides[this.activeIndex]
        updateControllerColor(activeSlide)
      },
      slideChange: function () {
        const activeSlide = this.slides[this.activeIndex]
        updateControllerColor(activeSlide)
      },
    },
  })
})
